import "bootstrap"
import 'admin-lte'
import "toastr"
import "./chart"
import "./custom"
import "./multi-select"